<template lang='pug'>
  v-layout(align-start)
    v-flex(xs12)
      v-row(dense justify='end')
        v-btn(color='primary' @click='dialogPlanificacion = true') Ver planificacion
      v-row
        v-col(cols='12')
          v-data-table.elevation-1(
            :headers='headers'
            :items='planificacionDia.clientes'
            :search='search'
            :loading='loading'
            loading-text='Cargando, por favor espere...'
            no-data-text='no existen clientes para mostrar')
            template(v-slot:top)
              v-toolbar(flat color='primary' dark)
                v-flex(class="d-flex flex-wrap justify-center")
                  v-toolbar-title Clientes del dia
                  v-divider.mx-4(inset vertical)
                  v-spacer
                  v-text-field.text-xs-center(v-model='search' label='Busqueda' single-line hide-details color='success')
            template(v-slot:item.action='{ item }')
              v-tooltip(bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(color='primary_2' @click='editItem(item)' v-on="on") mdi-account-details-outline
                | Visualizar

    v-dialog(v-model='dialog' scrollable max-width='90%')
      v-card(color='grey_1')
        v-app-bar(dark color='primary')
          v-toolbar-title.sub-head Cliente
          v-spacer
        v-card-text
          v-row(dense)
            v-col(cols='12')
              v-card
                v-card-text
                  v-row(dense)
                    v-col(cols='12' md='5')
                      v-text-field(
                        label='Cliente'
                        readonly
                        outlined
                        dense
                        v-model='form.idCliente.nombre')
          v-row(dense v-for='categoria in form.productos')
            v-col(cols='12')
              v-data-table.elevation-1(
                :items='categoria.productos'
                :headers='headersProductos'
                hide-default-footer
                :items-per-page='-1')
                template(v-slot:top)
                  v-toolbar.header-toolbar-compras(flat color='primary' dark dense)
                    v-flex(class="d-flex flex-wrap justify-center")
                      v-toolbar-title.main-head categoria: {{ categoria._id.descripcion }}
                      v-spacer
                template(v-slot:item.inventario='{ item }')
                  v-text-field(
                    type='number',
                    v-model.number='item.inventario',
                    min='0',
                    style='width: 125px',
                    dense)
                template(v-slot:item.fechaVencimiento='{ item }')
                  v-text-field(
                    type='date',
                    v-model='item.fechaVencimiento',
                    dense)
                template(v-slot:item.mueblePrincipal='{ item }')
                  v-text-field(
                    type='number',
                    v-model.number='item.mueblePrincipal',
                    min='0',
                    style='width: 100px',
                    dense)
                template(v-slot:item.muebleSecundario='{ item }')
                  v-text-field(
                    type='number',
                    v-model.number='item.muebleSecundario',
                    min='0',
                    style='width: 100px',
                    dense)
        v-card-actions
          v-spacer
          v-btn(color='error' small='' dark='' @click='close')
            v-icon mdi-close
            | Cancelar
          v-btn(color='success' small='' dark='' @click='save')
            v-icon mdi-content-save
            | Guardar

    v-dialog(v-model='dialogPlanificacion' scrollable max-width='90%')
      v-card(color='grey_1')
        v-app-bar(dark color='primary')
          v-toolbar-title.headline Planificacion
        v-card-text
          v-row(dense)
            v-col(cols='12')
              v-sheet(height='600')
                v-calendar(
                    ref="calendar",
                    locale='es',
                    v-model="value",
                    :events='planificacion',
                    :weekdays="weekday",
                    type="month",
                    @click:date='openModal')
        v-card-actions
          v-spacer
          v-btn(color='error' @click='dialogPlanificacion = false')
            v-icon mdi-close
            | Cerrar

    v-dialog(v-model='dialogPlanificacionClientes' scrollable max-width='90%')
      v-card(color='grey_1')
        v-app-bar(dark color='primary')
          v-toolbar-title.headline Clientes
        v-card-text
          v-row(dense)
            v-col(cols='12')
              v-data-table.elevation-1(:headers='headerClientes', :items='clientes')
        v-card-actions
          v-spacer
          v-btn(color='error' @click='dialogPlanificacionClientes = false')
            v-icon mdi-close
            | Cerrar
</template>

<script>
import Api from '@/services/methods'
export default {
  data: () => ({
    loading: false,
    search: '',
    dialog: false,
    dialogPlanificacion: false,
    dialogPlanificacionClientes: false,
    value: '',
    editedIndex: -1,
    weekday: [0, 1, 2, 3, 4, 5, 6],
    headers: [
      { text: 'Cliente', value: 'idCliente.nombre', align: 'left', sortable: false },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    headersProductos: [
      { text: 'SubCategoria', value: 'sublinea', align: 'left', sortable: false },
      { text: 'Producto', value: 'idProducto.nombre', align: 'left', sortable: false },
      { text: 'fecha Vencimiento', value: 'fechaVencimiento', align: 'left', sortable: false },
      { text: 'inventario', value: 'inventario', align: 'left', sortable: false },
      { text: 'Mueble Principal', value: 'mueblePrincipal', align: 'left', sortable: false },
      { text: 'Mueble Secundario', value: 'muebleSecundario', align: 'left', sortable: false }
    ],
    headerClientes: [
      { text: 'Nombre', value: 'idCliente.nombre', align: 'left', sortable: false },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    planificacionDia: {
      clientes: []
    },
    planificacion: [],
    fechaActual: '',
    form: {
      _id: '',
      productos: [],
      idCliente: {}
    },
    defaultForm: {
      _id: '',
      productos: [],
      idCliente: {}
    },
    productos: [],
    clientes: []
  }),

  created () {
    this.initialized()
  },

  methods: {
    initialized () {
      this.getPlanificacion()
      this.getProductos()
    },

    getPlanificacion () {
      Api.get('planificacion/promotor/clientes')
        .then(res => {
          if (res.data.diaActual) {
            this.planificacion = res.data.planificacion
            this.fechaActual = res.data.date
            this.planificacionDia = res.data.diaActual
          }
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    getProductos () {
      Api.get('planificacion/productos')
        .then(res => {
          this.productos = res.data
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    openModal (date) {
      this.dialogPlanificacionClientes = true
      const index = this.planificacion.findIndex(dia => dia.start === date.date)
      this.clientes = [...this.planificacion[index].clientes]
    },

    editItem (item) {
      this.editedIndex = this.planificacionDia.clientes.indexOf(item)
      this.form = Object.assign({}, item)
      if (this.form.productos && this.form.productos.length === 0) {
        this.form.productos = JSON.parse(JSON.stringify(this.productos))
      }
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.form = Object.assign({}, this.defaultForm)
      this.form.productos = []
    },

    save () {
      Api.put('planificacion/clientes', this.form)
        .then(res => {
          this.$swal({
            icon: 'success',
            title: 'Modificacion exitosa',
            text: 'Todos los cambios han sido efectuados'
          })
          this.close()
          // optimizar
          this.getPlanificacion()
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al guardar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    }

  }
}
</script>

<style>

</style>
